import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { HtmlText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/HtmlText';
import { convertToHtmlTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/texts.common';
import { Box } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

type Props = {
  textProps: CardTextProps;
  index: number;
  height: number;
  marginTop?: number;
};

export const ThreeUpParagraph = observer(function ThreeUpParagraph({
  textProps,
  index,
  height,
  marginTop = 0,
}: Props) {
  const effectiveMarginTop = index === 0 ? 0 : marginTop;

  const htmlTextProps = convertToHtmlTextProps(textProps);

  return (
    <Box
      width={textProps.maxWidth}
      // Pay attention: Normally you don't have to define height, but since the
      // internal `CardText` does not expose `heights` the `Box` element cannot size itself
      // based on the content. So the texts vertically overlap.
      // This is why all the fuss on calculating the text height in useEffect
      height={height}
      key={index + textProps.text}
      marginTop={effectiveMarginTop}
      centerAnchor
    >
      <HtmlText
        size={{ width: textProps.maxWidth!, height }}
        {...htmlTextProps}
      />
    </Box>
  );
});
